import type { TranslationStrings } from '@/types/i18n'

export const am: TranslationStrings = {
  // App
  appName: 'ሣጥማስ',
  appTagline: 'የአማርኛ ጽሑፍ ፍለጋ',

  // Header
  search: 'ፈልግ',
  searchPlaceholder: 'ፈልግ...',
  selectFileFirst: 'መጀመሪያ ፋይል ይምረጡ',
  signIn: 'ግባ',
  connected: 'ተገናኝቷል',
  offline: 'ከመስመር ውጭ',

  // Sidebar
  files: 'ፋይሎች',
  history: 'ታሪክ',
  favorites: 'ተወዳጆች',
  settings: 'ቅንብሮች',
  noFiles: 'ፋይሎች የሉም',
  uploadFilesToSearch: 'ለመፈለግ ፋይሎችን ይጫኑ',
  clickBookToLoad: 'መጽሐፍ ጠቅ አድርጉ ለመጫን',
  noHistory: 'ታሪክ የለም',
  recentSearchesAppearHere: 'የቅርብ ጊዜ ፍለጋዎች እዚህ ይታያሉ',
  noFavorites: 'ተወዳጆች የሉም',
  starSearchesToSaveThem: 'ፍለጋዎችን ለማስቀመጥ ኮከብ ያድርጉ',
  selectFileToStart: 'ፍለጋ ለመጀመር ፋይል ይምረጡ።',
  readyToSearch: 'ለመፈለግ ዝግጁ',

  // Input Methods
  inputFiles: 'ፋይሎች',
  inputPaste: 'ለጥፍ',
  inputUrl: 'URL',
  pasteTextHere: 'የአማርኛ ጽሑፍ እዚህ ይለጥፉ...',
  enterUrlHere: 'ጽሑፍ ለማምጣት URL ያስገቡ...',
  load: 'ጫን',
  fetch: 'አምጣ',
  useThisText: 'ይህን ጽሑፍ ተጠቀም',
  useSelectedText: 'የተመረጠውን ጽሑፍ ተጠቀም',
  pastedText: 'የተለጠፈ ጽሑፍ',
  urlContent: 'የURL ይዘት',
  textTooShort: 'ጽሑፉ በጣም አጭር ነው (ቢያንስ 10 ቁምፊዎች)',
  invalidUrl: 'እባክዎ ትክክለኛ URL ያስገቡ',
  selectInputMethod: 'ለመፈለግ ጽሑፍ እንዴት እንደሚጫን ይምረጡ',
  urlPreview: 'ከURL ቅድመ እይታ',
  selectSections: 'የሚካተቱ ክፍሎችን ይምረጡ',
  selectAll: 'ሁሉንም ምረጥ',
  deselectAll: 'ሁሉንም አትምረጥ',
  selectedCount: 'ተመርጠዋል',
  noContentFound: 'በዚህ URL ምንም የጽሑፍ ይዘት አልተገኘም',
  backToUrl: 'ተመለስ',
  viewAll: 'ሁሉንም ይመልከቱ',
  view: 'ይመልከቱ',
  close: 'ዝጋ',
  words: 'ቃላት',
  previous: 'ቀዳሚ',
  next: 'ቀጣይ',
  page: 'ገጽ',

  // Search
  selectFileToBegin: 'የአማርኛ ጽሑፍ ለመፈለግ ፋይል ይምረጡ',
  modes: 'ሁነታዎች',
  match: 'ተዛማጅ',
  literal: 'ቃል በቃል',
  position: 'አቀማመጥ',
  form: 'ቅርጽ',
  numbers: 'ቁጥሮች',
  sentences: 'ዓረፍተ ነገሮች',
  exact: 'ትክክለኛ',
  prefix: 'ቅድመ ቅጥያ',
  suffix: 'ድህረ ቅጥያ',
  contains: 'ይዟል',
  change: 'ቀይር',
  formPattern: 'የቅርጽ ስርዓተ ንድፍ',
  formPatternHint: '(0-9 ለአናባቢ ቅርጽ)',
  numberType: 'የቁጥር ዓይነት',
  digits: 'አሃዞች',
  written: 'በጽሑፍ',
  both: 'ሁለቱም',
  skip: 'ዝለል',
  repeat: 'ድገም',
  derivate: 'ተውሳኪ',
  skipCharacter: 'ይህን ቁምፊ አማራጭ አድርግ',
  repeatCharacter: 'ይህ ቁምፊ እንዲደገም ፍቀድ',
  exactCharacter: 'ይህን ቁምፊ ትክክለኛ አድርግ (ቤተሰብ የለም)',
  derivateWord: 'የተውሳኪ ማስፋፋት ተጠቀም',

  // Results
  resultsFor: 'ውጤቶች ለ',
  matches: 'ውጤቶች',
  matchSingular: 'ውጤት',
  categories: 'ምድቦች',
  categorySingular: 'ምድብ',
  all: 'ሁሉም',
  noMatchesFound: 'ውጤት አልተገኘም',
  tryAdjustingSearch: 'ፍለጋዎን ወይም አማራጮችን ያስተካክሉ',
  showMore: 'ተጨማሪ አሳይ',
  more: 'ተጨማሪ',
  searching: 'በመፈለግ ላይ...',

  // Settings
  language: 'ቋንቋ',
  languageDescription: 'የሚፈልጉትን ቋንቋ ይምረጡ',
  theme: 'ገጽታ',
  themeDescription: 'በራስጌ ላይ ባለው አዝራር ይቀይሩ',
  editTranslations: 'ትርጉሞችን አርትዕ',
  editTranslationsDescription: 'የUI ጽሑፍ ሕብረቁምፊዎችን ያበጁ',
  translationEditor: 'የትርጉም አርታኢ',
  searchTranslations: 'ትርጉሞችን ፈልግ...',
  save: 'አስቀምጥ',
  cancel: 'ሰርዝ',
  reset: 'ዳግም አስጀምር',
  english: 'እንግሊዝኛ',
  amharic: 'አማርኛ',

  // Editor
  editor: 'አርታኢ',
  newDocument: 'አዲስ ሰነድ',
  untitledDocument: 'ስም የሌለው ሰነድ',
  startTyping: 'መጻፍ ይጀምሩ...',
  loading: 'በመጫን ላይ',
  undo: 'መልስ',
  redo: 'ድገም',
  toggleSidebar: 'የጎን አሞሌ',
  bold: 'ወፍራም',
  italic: 'ሰያፍ',
  underline: 'ከስር መስመር',
  strikethrough: 'መሻገር',
  alignLeft: 'ወደ ግራ አሰልፍ',
  alignCenter: 'መሃል አሰልፍ',
  alignRight: 'ወደ ቀኝ አሰልፍ',
  bulletList: 'ነጥብ ዝርዝር',
  numberedList: 'ቁጥር ዝርዝር',
  insertImage: 'ምስል አስገባ',
  insertTable: 'ሰንጠረዥ አስገባ',
  horizontalRule: 'አግድም መስመር',
  quote: 'ጥቅስ',
  codeBlock: 'ኮድ',
  issues: 'ችግሮች',
  statistics: 'ስታቲስቲክስ',
  noIssuesFound: 'ምንም ችግር አልተገኘም',
  spelling: 'ፊደል አጻጻፍ',
  grammar: 'ሰዋስው',
  fidelForm: 'የፊደል ቅርጽ',
  characters: 'ቁምፊዎች',
  amharicPercent: 'አማርኛ',
  readingTime: 'የማንበቢያ ጊዜ',
  paragraphs: 'አንቀጾች',

  // Dictionary
  dictionary: 'መዝገበ ቃላት',
  dictionaryDescription: 'የክዳነ ወልድ ክፍሌ የአማርኛ መዝገበ ቃላት',
  searchDictionary: 'መዝገበ ቃላት ፈልግ...',
  definition: 'ትርጉም',
  synonyms: 'ተመሳሳይ ቃላት',
  relatedWords: 'ተዛማጅ ቃላት',
  examples: 'ምሳሌዎች',
  noResultsFound: 'ውጤት አልተገኘም',
  recentLookups: 'የቅርብ ጊዜ ፍለጋዎች',
  startSearchingDictionary: 'የአማርኛ ቃል ይፈልጉ',
  selectWordToView: 'ለማየት ቃል ይምረጡ',
  dictionaryHint: 'ትርጉም፣ ተመሳሳይ ቃላት እና ተዛማጅ ቃላትን ለማየት ቃላትን ይፈልጉ ወይም የቅርብ ጊዜ ፍለጋዎችን ያስሱ።',
  results: 'ውጤቶች'
}
